// extracted by mini-css-extract-plugin
module.exports = {"entry":"online-counter_entry__v2WZ_"};